import { AxiosPromise } from 'axios';
import { http } from 'services';
import type { Subject } from './types';

export interface CreateSubjectData {
  name: string;
  description?: string;
  color?: string;
}

export const List = (): AxiosPromise<{ success: boolean; data: Subject[] }> =>
  http.request.get('/api/subjects');

export const GetById = (id: string): AxiosPromise<{ success: boolean; data: Subject }> =>
  http.request.get(`/api/subjects/${id}`);

export const Create = (data: CreateSubjectData): AxiosPromise<{ success: boolean; data: Subject }> =>
  http.request.post('/api/subjects', data);

export const Update = (
  id: string,
  data: Partial<CreateSubjectData>,
): AxiosPromise<{ success: boolean; data: Subject }> =>
  http.request.patch(`/api/subjects/${id}`, data);

export const Delete = (id: string): AxiosPromise<{ success: boolean }> =>
  http.request.delete(`/api/subjects/${id}`);
